import Header from "./Header";
import Content from "./Content";
import Footer from "./Footer";
import { CartProvider } from "../products/CartContext";

function Template(props) {
  return (
    <div className="d-flex flex-column min-vh-100">
      <CartProvider>
        <Header />
        <Content>{props.children}</Content>
        <Footer />
      </CartProvider>
    </div>
  );
}

export default Template;
